import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManageUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "iconfinder_users_group_people_309041 1",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M13.5 13.5C13.5 10.95 15.45 9 18 9C20.55 9 22.5 10.95 22.5 13.5C22.5 16.05 20.55 18 18 18C15.45 18 13.5 16.05 13.5 13.5ZM18 21C11.1 21 9 25.95 9 25.95V28.5H27V25.95C27 25.95 24.9 21 18 21Z",
					fill: "currentColor"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_3",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M27.75 16.5C29.8211 16.5 31.5 14.8211 31.5 12.75C31.5 10.6789 29.8211 9 27.75 9C25.6789 9 24 10.6789 24 12.75C24 14.8211 25.6789 16.5 27.75 16.5Z",
						fill: "currentColor"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_4",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M27.7508 19.5C25.9508 19.5 24.6008 19.95 23.5508 20.7C27.0008 22.35 28.3508 25.2 28.3508 25.5V25.65H34.5008V23.7C34.5008 23.55 32.8508 19.5 27.7508 19.5Z",
						fill: "currentColor"
					})
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_5",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_6",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M27.75 16.5C29.8211 16.5 31.5 14.8211 31.5 12.75C31.5 10.6789 29.8211 9 27.75 9C25.6789 9 24 10.6789 24 12.75C24 14.8211 25.6789 16.5 27.75 16.5Z",
						fill: "currentColor"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_7",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_5",
						d: "M27.7508 19.5C25.9508 19.5 24.6008 19.95 23.5508 20.7C27.0008 22.35 28.3508 25.2 28.3508 25.5V25.65H34.5008V23.7C34.5008 23.55 32.8508 19.5 27.7508 19.5Z",
						fill: "currentColor"
					})
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_8",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_9",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_6",
						d: "M8.25 16.5C10.3211 16.5 12 14.8211 12 12.75C12 10.6789 10.3211 9 8.25 9C6.17893 9 4.5 10.6789 4.5 12.75C4.5 14.8211 6.17893 16.5 8.25 16.5Z",
						fill: "currentColor"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_10",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_7",
						d: "M8.25 19.5C10.05 19.5 11.4 19.95 12.45 20.7C9 22.35 7.65 25.2 7.65 25.5V25.65H1.5V23.7C1.5 23.55 3.15 19.5 8.25 19.5Z",
						fill: "currentColor"
					})
				})]
			})
		]
	})
});
export default SvgManageUsers;
